// AUTO-GENERATED by scripts/gen-hand-model.mjs — DO NOT EDIT.
// Source: carbonsix-models@a3c5194 robots/sigma_hand/descriptor/sigma_hand.urdf
// 갱신: npm run gen:hand-model (상세: 같은 폴더 MODELS.md)

export interface SigmaHandJointSpec {
  name: string;
  parentLink: string;
  childLink: string;
  /** 부모 링크 프레임 기준 관절 원점(m) */
  originXyz: [number, number, number];
  /** 관절 원점 RPY(rad, URDF 규약 Rz·Ry·Rx) */
  originRpy: [number, number, number];
  /** 회전축(관절 프레임 기준) */
  axis: [number, number, number];
  /** 드라이버 각도에 곱하는 총 배수(mimic 체인 환산). fixed 관절은 0. */
  multiplier: number;
}

/** 루트 링크 — 손 전체 프레임의 기준 */
export const SIGMA_HAND_ROOT_LINK = "base_link";

/** 유일한 실구동 관절(나머지는 전부 mimic) */
export const SIGMA_HAND_DRIVER_JOINT = "JR1";

/** 드라이버 관절 리밋(rad) */
export const SIGMA_HAND_DRIVER_LIMITS = {
  lower: -0.97,
  upper: 0,
};

export const SIGMA_HAND_REVOLUTE_JOINTS: SigmaHandJointSpec[] = [
  {
    name: "JR1",
    parentLink: "base_link",
    childLink: "right_l1",
    originXyz: [0.06, -0.015, 0.03],
    originRpy: [0, 0, 0],
    axis: [0, 0, 1],
    multiplier: 1,
  },
  {
    name: "JR2",
    parentLink: "right_l1",
    childLink: "right_f",
    originXyz: [0.084939, -0.0036812, 0],
    originRpy: [0, 0, 0],
    axis: [0, 0, 1],
    multiplier: -1,
  },
  {
    name: "JRF",
    parentLink: "base_link",
    childLink: "right_l2",
    originXyz: [0.051449, -0.038492, 0.03],
    originRpy: [0, 0, 0],
    axis: [0, 0, 1],
    multiplier: 1,
  },
  {
    name: "JL1",
    parentLink: "base_link",
    childLink: "left_l1",
    originXyz: [0.06, 0.015, 0.03],
    originRpy: [0, 0, 0],
    axis: [0, 0, 1],
    multiplier: -1,
  },
  {
    name: "JL2",
    parentLink: "left_l1",
    childLink: "left_f",
    originXyz: [0.084939, 0.0036812, 0],
    originRpy: [0, 0, 0],
    axis: [0, 0, 1],
    multiplier: 1,
  },
  {
    name: "JLF",
    parentLink: "base_link",
    childLink: "left_l2",
    originXyz: [0.051449, 0.038492, 0.03],
    originRpy: [0, 0, 0],
    axis: [0, 0, 1],
    multiplier: -1,
  },
];

export const SIGMA_HAND_FIXED_JOINTS: SigmaHandJointSpec[] = [
  {
    name: "right_end_joint",
    parentLink: "right_f",
    childLink: "right_end",
    originXyz: [0.06614, 0.018681, -0.0075499],
    originRpy: [0, 0, 0],
    axis: [0, 0, 0],
    multiplier: 0,
  },
  {
    name: "left_end_joint",
    parentLink: "left_f",
    childLink: "left_end",
    originXyz: [0.06614, -0.018681, -0.00755],
    originRpy: [0, 0, 0],
    axis: [0, 0, 0],
    multiplier: 0,
  },
];

/** 링크명 → sigma_hand_links.glb 안의 메시 노드명(동일) */
export const SIGMA_HAND_MESH_LINKS: string[] = [
  "base_link",
  "right_l1",
  "right_f",
  "right_end",
  "right_l2",
  "left_l1",
  "left_f",
  "left_end",
  "left_l2",
];
